export default __webpack_public_path__ + "delivery-tile-bg.3d188a73391105d5da20110ccd00e5ef.png";